import React from "react";
import {
  FaYoutube,
  FaSpotify,
  FaApple,
  FaAmazon,
  FaInstagram,
} from "react-icons/fa6";
import { SiYoutubemusic } from "react-icons/si";
import site from "../content/site.json";
import { externalLinkProps } from "../lib/links";

const ICON_MAP = {
  FaYoutube,
  FaSpotify,
  FaApple,
  FaAmazon,
  FaInstagram,
  SiYoutubemusic,
};

const WatchAndListen = () => {
  const { watchAndListen } = site;
  return (
    <section
      data-testid="watch-and-listen-section"
      className="py-20 md:py-24 bg-ivory"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
          {watchAndListen.overline}
        </p>
        <h2 className="mt-4 font-heading font-normal text-charcoal text-4xl sm:text-5xl md:text-6xl tracking-tight">
          {watchAndListen.heading}
        </h2>
        <div className="mt-8 mx-auto w-12 h-px bg-muted_gold" />
        <p className="mt-8 max-w-2xl mx-auto text-charcoal-soft text-lg leading-relaxed">
          {watchAndListen.description}
        </p>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {watchAndListen.platforms.map((p) => {
            const Icon = ICON_MAP[p.icon];
            return (
              <a
                key={p.name}
                href={p.href}
                {...externalLinkProps(p.href)}
                data-testid={p.testId}
                aria-label={`Open TATTVAM on ${p.name}`}
                className="group flex flex-col items-center justify-center gap-3 border border-charcoal/25 px-4 py-5 hover:border-muted_gold hover:bg-ivory-deeper transition-all duration-500"
              >
                {Icon ? (
                  <Icon
                    size={32}
                    className="text-charcoal group-hover:text-muted_gold transition-colors duration-500"
                  />
                ) : null}
                <span className="text-xs tracking-[0.24em] uppercase font-medium text-charcoal group-hover:text-charcoal transition-colors duration-500">
                  {p.name}
                </span>
              </a>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default WatchAndListen;
